// src/components/TimeframeSelector.js

import React from "react";
import "../styles/TimeframeSelector.css";

const OPTIONS = [
  { value: "30d", label: "Last 30 days" },
  { value: "3m", label: "Last 3 months" },
  { value: "6m", label: "Last 6 months" },
  { value: "ytd", label: "Year to date" },
  { value: "all", label: "All time" },
];

export default function TimeframeSelector({ value, onChange }) {
  return (
    <div className="timeframe-selector">
      <label htmlFor="timeframe">Timeframe</label>
      <select
        id="timeframe"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
